export default __webpack_public_path__ + "static/media/hm-ag-img.36e6f6dc.webp";